import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'flow-form-radio-group',
  templateUrl: './form-radio-group.component.html',
  styleUrls: ['./form-radio-group.component.scss'],
})
export class FormRadioGroupComponent implements ControlValueAccessor {
  @Input() deviceOptions: { value: any; label: string; description: string }[] = [];
  @Input() disabled: boolean = false;
  private formDisabled: boolean = false;
  selectedValue: any = null;

  get isDisabled(): boolean {
    return this.disabled || this.formDisabled;
  }

  constructor(@Optional() @Self() protected control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.formDisabled = isDisabled;
  }

  onSelect(value: any) {
    if (!this.isDisabled) {
      this.selectedValue = value;
      this.onChange(value);
      this.onTouched();
    }
  }
}
